const invaildJsonToken = {
  '```json': '',
  '```': '',
  '\\&': '&',
  '}, ]': '}]'
};
export const getObjectContent = (/** @type {string} */ str, /** @type {string} [gemini] */ model) => {
  let text;
  switch (model) {
    case 'gemini':
    default:
      text = str;
      Object.entries(invaildJsonToken).forEach(([key, value]) => {
        text = text.replaceAll(key, value);
      });
  }

  if (!text) {
    return undefined;
  } else {
    try {
      return JSON.parse(text);
    } catch (error) {
      console.log('error: ', error);
      console.log('text: ', text);
      return [text];
    }
  }
};
